import { withdrawAnalyticsConsent } from "@/lib/client/analytics";
import { COOKIE_CONSENT_CHANGED_EVENT } from "@/lib/client/referralTracking";

const OPTIONAL_COOKIE_NAMES = ["cookieConsent", "_ga", "_gid", "_gat", "_clck", "_clsk"];
const OPTIONAL_COOKIE_PREFIXES = ["_ga_", "_gac_", "_gcl_"];
const REFERRAL_ANALYTICS_KEY = "kurb_ga_referral_code";

const isOptionalCookie = (name: string) =>
  OPTIONAL_COOKIE_NAMES.includes(name) ||
  OPTIONAL_COOKIE_PREFIXES.some((prefix) => name.startsWith(prefix));

const expireCookie = (name: string, domain?: string) => {
  const domainAttribute = domain ? `; domain=${domain}` : "";
  document.cookie = `${name}=; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainAttribute}; samesite=lax`;
};

/** Remove optional analytics data without signing the user out or deleting app preferences. */
export const deleteOptionalAnalyticsData = () => {
  if (typeof window === "undefined") return;

  withdrawAnalyticsConsent();

  try {
    sessionStorage.removeItem(REFERRAL_ANALYTICS_KEY);
  } catch {
    // Continue when storage access is restricted.
  }

  const domains = window.location.hostname.endsWith("kurb.online")
    ? [undefined, ".kurb.online"]
    : [undefined];

  try {
    const cookieNames = document.cookie
      .split(";")
      .map((cookie) => cookie.split("=")[0]?.trim())
      .filter((name): name is string => Boolean(name) && isOptionalCookie(name));

    for (const name of cookieNames) {
      for (const domain of domains) {
        expireCookie(name, domain);
      }
    }

    // The consent cookie may be absent from document.cookie in restricted browser modes.
    for (const domain of domains) {
      expireCookie("cookieConsent", domain);
    }
  } catch {
    // The consent-change event still lets mounted integrations turn themselves off.
  }

  window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGED_EVENT));
};
